var React = require('react');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var { $form, $simpleSelect, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var MemberAppFuncs = require('../../MembershipApplication/ReactDependencies/memberAppFuncs.jsx');

class LicenseInformation extends React.Component {
    constructor(props) {
        super(props);

        this.getNpiNumberMarkup = this.getNpiNumberMarkup.bind(this);
        this.getPrimaryPracticeDropdownMarkup = this.getPrimaryPracticeDropdownMarkup.bind(this);
        this.getPrimaryPracticeTooltipContent = this.getPrimaryPracticeTooltipContent.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePrimaryPracticeChange = this.handlePrimaryPracticeChange.bind(this);
        this.handlePrimaryDistrictChange = this.handlePrimaryDistrictChange.bind(this);
    }

    getPrimaryPracticeTooltipContent() {
        if (memberTypeChecker.stateOfPrimaryPracticeInfoExceptionA(this.props.appState.appType)) {
            return 'Equals residency institution state, or fellowship institution state.';
        }

        if (memberTypeChecker.stateOfPrimaryPracticeInfoExceptionB(this.props.appState.appType)) {
            return 'Equals medical school institution state.';
        }

        if (memberTypeChecker.stateOfPrimaryPracticeInfoExceptionC(this.props.appState.appType)) {
            return 'Equals training program state.';
        }

        return 'Default Primary Practice Info Content';
    }

    getPrimaryPracticeDropdownMarkup() {
        if (memberTypeChecker.stateOfPrimaryPracticeHide(this.props.appState.appType)) {
            return null;
        }

        var modalFunc = function () {
            return this.props.showInfoModal('primaryPracticeLocation');
        }.bind(this);

        var label = this.props.hasModalInfo('primaryPracticeLocation') ? <span onClick={modalFunc}><span className={"get-info"}>{this.props.getInfoModalContent("primaryPracticeLocation").infoIconLabel}</span></span> : null;

        return <div>
            <label>{labels.step4.stateOfPrimaryPractice} {label}</label>
            <$simpleSelect
                value={this.props.stepState.primaryPracticeLocation}
                selectoptions="statesByCountry"
                name="primaryPracticeLocation"
                selectdatafunction={selectableDataFunctions.getMedicalLicenseStates}
                military={this.props.appState.isMilitary ? this.props.appState.isMilitary.toString() : ''}
                disabled={this.props.appState.isMilitary}
                valueprop="StateCode"
                labelprop="StateDescription"
                onChange={this.handlePrimaryPracticeChange}
                validations={[validationFunctions.required]} /><br />
        </div>;
    }

    getDistrictDropdownMarkup() {

        if (!this.props.stepState.primaryPracticeLocation) {
            return null;
        }

        var primaryPracticeLocation = this.props.stepState.primaryPracticeLocation.toUpperCase();
        var primaryPracticeLocationLC = this.props.stepState.primaryPracticeLocation.toLowerCase();
        var availableDistricts = MemberAppFuncs.districtCount(primaryPracticeLocation);
        
        if (memberTypeChecker.stateOfPrimaryPracticeHide(this.props.appState.appType) || memberTypeChecker.districtHide(this.props.appState.appType) || availableDistricts == 0) {
            return null;
        }

        var modalFunc = function () {
            return this.props.showInfoModal('primaryDistrictLocation');
        }.bind(this);

        var modalInfoFunc = function () {
            return this.props.showInfoModal(primaryPracticeLocationLC + "districtinfo");
        }.bind(this);

        var label = this.props.hasModalInfo('primaryDistrictLocation') ? <span onClick={modalFunc}><span className={"get-info"}>{this.props.getInfoModalContent("primaryDistrictLocation").infoIconLabel}</span></span> : null;
        var info = this.props.hasModalInfo(primaryPracticeLocationLC + "districtinfo") ? <span onClick={modalInfoFunc}><span className={"get-info"}>{this.props.getInfoModalContent(primaryPracticeLocationLC + "districtinfo").infoIconLabel}</span></span> : null;

        return <div>
            <label>{labels.step4.districtOfPrimaryPractice} {label} {info}</label>
            <$simpleSelect
                value={this.props.stepState.primaryDistrictLocation}
                ppl={this.props.stepState.primaryPracticeLocation}
                selectoptions="districtsByState"
                name="primaryDistrictLocation"
                selectdatafunction={selectableDataFunctions.getApiDistricts}
                valueprop="DistrictCode"
                labelprop="DistrictDescription"
                onChange={this.handlePrimaryDistrictChange}
                validations={[validationFunctions.required]} /><br />
        </div>;
    }

    getNpiNumberMarkup() {
        if (memberTypeChecker.hideNpiNumber(this.props.appState.appType)) {
            return null;
        }

        var validations = memberTypeChecker.requireNpiNumber(this.props.appState.appType)
            ? [validationFunctions.required, validationFunctions.npiNumber]
            : [validationFunctions.npiNumber];

        return <div>
            <span>{labels.step4.npiNumber}</span><br />
            <$input type="text" value={this.props.stepState.npiNumber} name="npiNumber" onChange={this.handleInputChange} validations={validations}/>
        </div>;
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    handlePrimaryPracticeChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
        this.props.updateStepState("primaryDistrictLocation", null);       
    }

    handlePrimaryDistrictChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);    
    }
    
    render() {
        if (memberTypeChecker.hideNpiNumber(this.props.appState.appType) &&
            memberTypeChecker.stateOfPrimaryPracticeHide(this.props.appState.appType)) {
            return null;
        }

        return <div className={"license-information-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step4.licenseInformation}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            {this.getPrimaryPracticeDropdownMarkup()}
							{this.getDistrictDropdownMarkup()}                           
                            {this.getNpiNumberMarkup()}
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = LicenseInformation;